import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DadosMenuPrincipal } from "app/types/DadosMenuPrincipal";
import { resetAll } from "./actions/resetAll";

const initialState: DadosMenuPrincipal = {};

export const menuPrincipalSlice = createSlice({
    name: "menuPrincipal",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        atualizarMenuPrincipal: (state, action: PayloadAction<DadosMenuPrincipal>) => {
            // Atualização seletiva - somente se houve mudanças reais
            if (state !== action.payload) {
                return action.payload;
            }
            return state;
        },
        limparMenuPrincipal: () => initialState
    },
})

export const {
    atualizarMenuPrincipal: atualizarMenuPrincipalAction,
    limparMenuPrincipal: limparMenuPrincipalAction
} = menuPrincipalSlice.actions

export default menuPrincipalSlice.reducer